export default "\r\n <img class=\"img\" (click)=\"clicked()\" src=\"{{photoB64Event}}\" style=\"cursor: pointer\">\r\n";